import AHttpService from '@d-services/a-http-service/a-http-service';
import { addObjectToFormData } from '@d-shared/forms/forms';
import URLS from '@d-shared/urls/urls';

class UserReviewsService extends AHttpService {
  async addUserReviewUpvote(slug) {
    const url = URLS.api.userReviews.upvote.replace('<slug>', slug);
    const response = await this._http.post(url, null);
    return response.data;
  }

  async getUserReviewUpvotes(slug, page = 1) {
    const url = `${ URLS.api.userReviews.upvotes.replace('<slug>', slug) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getUserReviewsForBook(bookSlug, sortBy = null, rating = null, page = 1) {
    let url = `${ URLS.api.book.userReviews.replace('<book-slug>', bookSlug) }?page=${ page }`;

    if (sortBy) {
      url += `&order_by=${ sortBy }`;
    }

    if (rating) {
      url += `&rating=${ rating }`;
    }

    const response = await this._http.get(url);
    return response.data;
  }

  async getUserReviewsCountForBook(bookSlug) {
    const url = URLS.api.book.userReviewsCount.replace('<book-slug>', bookSlug);
    const response = await this._http.get(url);
    return response.data;
  }

  async removeUserReviewUpvote(slug) {
    const url = URLS.api.userReviews.upvote.replace('<slug>', slug);
    const response = await this._http.delete(url);
    return response.data;
  }

  async addUserReviewFeedback(slug, payload) {
    const formData = new FormData();
    addObjectToFormData(payload, formData);

    const url = URLS.api.author.feedback.replace('<book-slug>', slug);
    const response = await this._http.post(url, formData);
    return response.data;
  }
}

export default new UserReviewsService();
